import { cadastroRegisterMappingKeys } from './mappings';

export default rawData => {
    let obj = {};
    
    Object.keys(cadastroRegisterMappingKeys).forEach(key => {
        obj[cadastroRegisterMappingKeys[key]] = rawData[key];
    });
    return obj;
};